<route>
{
  "meta": {
    "permission": [
      "sales.view_order",
      "sales.view_orderproduct"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <v-tabs
      v-if="checkPermissions.isElevatedRole"
      class="mb-2"
      color="primary"
      next-icon="fa-chevron-right"
      prev-icon="fa-chevron-left"
      centered
      show-arrows
      :icons-and-text="$vuetify.breakpoint.smAndUp"
      v-model="tabs"
    >
      <v-tab class="pt-3">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['all'])"
        >
          <span
            class="pt-2"
            v-if="$vuetify.breakpoint.smAndUp"
            v-text="$t('all')"
          ></span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">fas fa-file</v-icon>
        </v-badge>
      </v-tab>
      <v-tab class="pt-3" href="#draft">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['draft'])"
        >
          <span
            v-show="$vuetify.breakpoint.smAndUp"
            class="pt-2"
            v-text="$t('draft')"
          ></span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">
            fas fa-file-signature
          </v-icon>
        </v-badge>
      </v-tab>
      <v-tab class="pt-3" href="#quote">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['quote'])"
        >
          <span
            v-show="$vuetify.breakpoint.smAndUp"
            class="pt-2"
            v-text="$t('quote')"
          ></span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">
            fa-file-contract
          </v-icon>
        </v-badge>
      </v-tab>
      <v-tab class="pt-3" href="#sended_quote">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['sended_quote'])"
        >
          <span
            v-show="$vuetify.breakpoint.smAndUp"
            class="pt-2"
            v-text="$t('sended_quote')"
          ></span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">
            fa-file-contract
          </v-icon>
        </v-badge>
      </v-tab>
      <v-tab class="pt-3" href="#in_process">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['in_process'])"
        >
          <span
            v-show="$vuetify.breakpoint.smAndUp"
            class="pt-2"
            v-text="$t('in_process')"
          ></span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">fa-file-image</v-icon>
        </v-badge>
      </v-tab>
      <v-tab class="pt-3" href="#production_ready">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['production_ready'])"
        >
          <span
            v-show="$vuetify.breakpoint.smAndUp"
            class="pt-2"
            v-text="$t('production_ready')"
          ></span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">
            fa fa-shipping-fast
          </v-icon>
        </v-badge>
      </v-tab>
      <v-tab class="pt-3" href="#delivery">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['delivery'])"
        >
          <span
            v-show="$vuetify.breakpoint.smAndUp"
            class="pt-2"
            v-text="$t('delivery')"
          ></span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">
            fa fa-shipping-fast
          </v-icon>
        </v-badge>
      </v-tab>
      <v-tab class="pt-3" href="#finished">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['finished'])"
        >
          <span
            v-show="$vuetify.breakpoint.smAndUp"
            class="pt-2"
            v-text="$t('finished')"
          ></span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">fa-file-image</v-icon>
        </v-badge>
      </v-tab>
      <!--
      <v-tab class="pt-3" href="#correction">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['correction'])"
        >
          <span
            v-show="$vuetify.breakpoint.smAndUp"
            class="pt-2"
            v-text="$t('correction')"
          ></span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">fa-file-archive</v-icon>
        </v-badge>
      </v-tab>
      -->
      <!--
      <v-tab class="pt-3" href="#canceled">
        <v-badge
          class="d-flex flex-column-reverse"
          bordered
          :content="String(orderStatus['canceled'])"
        >
          <span
            v-show="$vuetify.breakpoint.smAndUp"
            class="pt-2"
            v-text="$t('canceled')"
          >
          </span>
          <v-icon :medium="$vuetify.breakpoint.smAndUp">fa-file-excel</v-icon>
        </v-badge>
      </v-tab>
      -->
    </v-tabs>
    <v-card>
      <!-- Listado de todas las subórdenes de venta -->
      <div v-if="tabs === 0">
        <i-card-list
          app="sales.order"
          api="sale.suborder"
          dontCreate
          dontRemove
          dontEdit
          simple
          :opt="subOrderListOpt"
          :search.sync="dataForSearch"
          :title="$t('salessuborderlist')"
          @changeShowMode="changeShowMode"
        >
          <template v-slot:[`item`]="{ item, showMode }">
            <v-card-text>
              <v-row class="my-0">
                <!-- Imagen: (solo si showMode es grid o list) -->
                <v-col
                  v-if="showMode !== 'simple'"
                  class="d-flex justify-content-center"
                  :cols="showMode === 'grid' ? 12 : 2"
                >
                  <i-image
                    class="product-image"
                    :style="{
                      width: '10em !important',
                      height: '8em !important'
                    }"
                    :value="item.thumbnail"
                    :preview="true"
                    :readonly="true"
                  />
                </v-col>

                <!-- Cliente, total y vendedor -->
                <v-col
                  class="d-flex flex-column justify-content-center pt-0 g-1"
                  cols="12"
                  :md="showMode != 'grid' ? 2 : 12"
                >
                  <p class="mb-0">
                    <span class="primary--text font-weight-black">
                      {{ `${$tc('customer', 1)}: ` }}
                    </span>
                    <span class="primary--text subtitle-2">
                      {{ item.clientName || item.clientFullname }}
                    </span>
                    <customer-chat-button
                      :customer="item.customerPK"
                      :order="item.order"
                    />
                  </p>
                  <p
                    v-if="
                      !checkPermissions.isDesigner &&
                      !checkPermissions.isProducer
                    "
                    class="mb-0"
                  >
                    <span class="primary--text font-weight-black">
                      {{ `${$tc('total', 1)}: ` }}
                    </span>
                    <span class="primary--text subtitle-2">
                      <i-money :value="item.total" mode="text" />
                    </span>
                  </p>
                  <p class="mb-0">
                    <span class="primary--text font-weight-black">
                      {{ `${$tc('salesman', 1)}: ` }}
                    </span>
                    <span class="primary--text subtitle-2">
                      {{ item.salesmanName }}
                    </span>
                  </p>
                </v-col>

                <!-- Subórdenes -->
                <v-col
                  class="pt-0"
                  cols="12"
                  :md="showMode == 'simple' ? 7 : showMode == 'list' ? 5 : 12"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span
                          class="primary--text subtitle-2 font-weight-black"
                        >
                          {{ $tc('suborder', 1) }} ({{ item.own_prod }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <single-suborder
                    :order="item.order"
                    :subOrder="item.pk"
                    :openModal="openModal"
                    @closeModal="clearUrlQuery"
                    @done="updateSingleSuborderStatus(item, $event)"
                  />
                </v-col>

                <!-- Fecha, fecha compromiso y estado -->
                <v-col
                  class="suborders-info"
                  cols="12"
                  :md="showMode != 'grid' ? 3 : 12"
                >
                  <p class="text-right mb-0 font-weight-bold caption">
                    <span>{{ $t('date') }}</span>
                    <span class="primary--text">
                      {{ dateFormat(item.orderDate) }}
                    </span>
                  </p>
                  <p
                    v-if="item.promiseDate != null"
                    class="text-right mb-0 font-weight-bold caption"
                  >
                    <span>
                      {{ `${$t('promise_date')}` }}
                    </span>
                    <span class="primary--text">
                      {{ `${dateFormat(item.promiseDate)}` }}
                    </span>
                  </p>
                  <p
                    v-if="item.dateDone != null"
                    class="text-right mb-0 font-weight-bold caption"
                  >
                    <span>{{ `${$t('dateDone')}` }}</span>
                    <span class="primary--text">
                      {{ `${dateFormat(item.dateDone)}` }}
                    </span>
                  </p>
                  <p class="text-right mb-0 font-weight-bold caption">
                    <span>{{ `${$t('orderstatus')}:` }}</span>
                    <span class="primary--text font-weight-black">
                      {{ `${$t(item.orderMain)}` }}
                    </span>
                  </p>
                  <p
                    v-if="
                      item &&
                      (item.orderStatus || '').toString().trim() &&
                      !(
                        Array.isArray(item.mainStatus)
                          ? item.mainStatus.join(' ')
                          : item.mainStatus || ''
                      ).includes('draft')
                    "
                    class="text-right mb-0 font-weight-bold caption"
                  >
                    <span>{{ `${$t('suborderstatus')}:` }}</span>
                    <span class="primary--text font-weight-black">
                      {{
                        `${$tc(item.orderStatus.split(' - ')[0], 1)} -
                        ${$t(item.orderStatus.split(' - ')[1])}`
                      }}
                    </span>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </i-card-list>
      </div>

      <!-- Listado por subórdenes de venta -->
      <div v-if="tabs !== 0 && showGlobalMode === 'simple'">
        <i-card-list
          ref="cardListSimple"
          app="sales.order"
          api="sale.suborder"
          dontRemove
          dontHeader
          simple
          :opt="orderListOpt"
          :search.sync="dataForSearch"
          :title="$t('salessuborderlist')"
          @click:create="checkPermissions.add && changeRoute({ pk: 'create' })"
          @click:edit="
            checkPermissions.edit && changeRoute({ pk: $event.order })
          "
          @changeShowMode="changeShowMode"
        >
          <template v-slot:[`item`]="{ item, showMode }">
            <v-card-text>
              <v-row class="my-0">
                <!-- Cliente, total y vendedor -->
                <v-col
                  class="d-flex flex-column justify-content-center pt-0 g-1"
                  cols="12"
                  md="2"
                >
                  <p class="mb-0">
                    <span class="primary--text font-weight-black">
                      {{ `${$tc('customer', 1)}: ` }}
                    </span>
                    <span class="primary--text subtitle-2">
                      {{ item.clientName || item.clientFullname }}
                    </span>
                    <customer-chat-button
                      :customer="item.customerPK"
                      :order="item.order"
                    />
                  </p>
                  <p class="mb-0">
                    <span class="primary--text font-weight-black">
                      {{ `${$tc('total', 1)}: ` }}
                    </span>
                    <span class="primary--text subtitle-2">
                      <i-money :value="item.total" mode="text" />
                    </span>
                  </p>
                  <p class="mb-0">
                    <span class="primary--text font-weight-black">
                      {{ `${$tc('salesman', 1)}: ` }}
                    </span>
                    <span class="primary--text subtitle-2">
                      {{ item.salesmanName }}
                    </span>
                  </p>
                </v-col>

                <!-- Subórdenes -->
                <v-col class="pt-0" cols="12" md="7">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span
                          class="primary--text subtitle-2 font-weight-black"
                        >
                          {{ $tc('suborder', 1) }} ({{ item.own_prod }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <single-suborder
                    v-if="item.pk && item.order"
                    :order="item.order"
                    :subOrder="item.pk"
                    :openModal="openModal"
                    showSubOrderTitle
                    @closeModal="clearUrlQuery"
                    @done="updateSingleSuborderStatus(item, $event)"
                  />
                </v-col>

                <!-- Acciones, fecha, fecha compromiso y estado -->
                <v-col
                  class="suborders-info"
                  cols="12"
                  :md="showMode != 'grid' ? 3 : 12"
                >
                  <!-- Acciones -->
                  <p
                    v-if="checkPermissions.delete && item.order"
                    class="text-right mb-2"
                  >
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="secondary"
                          small
                          v-on="on"
                          @click="
                            getCartList(
                              item.order,
                              item.orderMain,
                              item.customerPK
                            )
                          "
                        >
                          {{ $t('action') }}
                        </v-btn>
                      </template>
                      <v-list>
                        <!-- Enviar cotización -->
                        <v-list-item v-if="item.orderMain === 'quote'">
                          <i-btn
                            classes="mx-1"
                            color="success"
                            icon="fa-paper-plane"
                            outlined
                            :title="$tc('send_quote')"
                            @click="update('send')"
                          />
                        </v-list-item>

                        <!-- Aprobar cotización -->
                        <v-list-item
                          v-if="
                            item.orderMain === 'quote' ||
                            item.orderMain === 'sended_quote'
                          "
                        >
                          <i-btn
                            classes="mx-1"
                            color="success"
                            icon="fa-check"
                            outlined
                            :title="$t('aproved_quote')"
                            @click="update('approved')"
                          />
                        </v-list-item>

                        <!-- Agregar productos / Carrito -->
                        <v-list-item
                          v-if="
                            item.orderMain === 'draft' ||
                            item.orderMain === 'quote'
                          "
                        >
                          <i-btn
                            classes="mx-1"
                            color="info"
                            icon="fa-cart-plus"
                            outlined
                            :title="`${$t('add', {
                              value: $tc('product', 2)
                            })}`"
                            @click="changeRoute({ pk: item.order }, 2)"
                          />
                        </v-list-item>

                        <!-- Descargar cotización en PDF -->
                        <v-list-item v-if="item.orderMain !== 'draft'">
                          <i-btn
                            classes="mx-1"
                            color="error"
                            icon="fa-file-download"
                            outlined
                            :title="$t('download', { value: $t('quote') })"
                            @click="
                              generatePDF(
                                item.order,
                                true,
                                item.code,
                                item.quotation_code,
                                item.orderMain
                              )
                            "
                          />
                        </v-list-item>

                        <!-- Mostrar la cotización en una ventana -->
                        <v-list-item v-if="item.orderMain !== 'draft'">
                          <i-btn
                            classes="mx-1"
                            color="error"
                            icon="fa-file-pdf"
                            outlined
                            :title="$t('print', { value: $t('quote') })"
                            @click="
                              generatePDF(
                                item.order,
                                false,
                                item.code,
                                item.quotation_code,
                                item.orderMain
                              )
                            "
                          />
                        </v-list-item>

                        <!-- Ir a la cuenta por cobrar -->
                        <v-list-item
                          v-if="
                            item.orderMain !== 'draft' &&
                            item.orderMain !== 'quote' &&
                            item.orderMain !== 'sended_quote'
                          "
                        >
                          <i-btn
                            classes="mx-1"
                            color="secondary"
                            icon="fa-file-invoice"
                            outlined
                            :title="$t('receivable')"
                            @click="goToReceivable(item.order)"
                          />
                        </v-list-item>

                        <!-- Eliminar orden -->
                        <v-list-item v-if="item.orderMain === 'draft'">
                          <i-btn
                            classes="mx-1"
                            color="error"
                            icon="fa-trash"
                            outlined
                            :title="$tc('delete', 1)"
                            @click="remove(item.order)"
                          />
                        </v-list-item>

                        <!-- Cancelar cotización -->
                        <v-list-item v-if="item.orderMain !== 'draft'">
                          <i-btn
                            classes="mx-1"
                            color="error"
                            icon="fa-times"
                            outlined
                            :title="`${$t('cancel')} ${$t('quote')}`"
                            @click="update('canceled')"
                          />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </p>

                  <!-- Fecha -->
                  <p class="text-right mb-0 font-weight-bold caption">
                    <span>{{ `${$t('date')}:` }}</span>
                    <span class="primary--text">
                      {{ dateFormat(item.orderDate) }}
                    </span>
                  </p>

                  <!-- Fecha de compromiso -->
                  <p
                    v-if="item.promiseDate != null"
                    class="text-right mb-0 font-weight-bold caption"
                  >
                    <span>
                      {{ `${$t('promise_date')}:` }}
                    </span>
                    <span class="primary--text">
                      {{ dateFormat(item.promiseDate) }}
                    </span>
                  </p>

                  <!-- Fecha de cierre -->
                  <p
                    v-if="item.dateDone != null"
                    class="text-right mb-0 font-weight-bold caption"
                  >
                    <span>{{ `${$t('dateDone')}:` }}</span>
                    <span class="primary--text">
                      {{ dateFormat(item.dateDone) }}
                    </span>
                  </p>

                  <!-- Estado de la orden -->
                  <p class="text-right mb-0 font-weight-bold caption">
                    <span>{{ `${$t('orderstatus')}:` }}</span>
                    <span class="primary--text font-weight-black">
                      {{ $t(item.orderMain) }}
                    </span>
                  </p>

                  <!-- Estado de la suborden -->
                  <p
                    v-if="
                      item &&
                      (item.orderStatus || '').toString().trim() &&
                      !(
                        Array.isArray(item.mainStatus)
                          ? item.mainStatus.join(' ')
                          : item.mainStatus || ''
                      ).includes('draft')
                    "
                    class="text-right mb-0 font-weight-bold caption"
                  >
                    <span>{{ `${$t('suborderstatus')}:` }}</span>
                    <span class="primary--text font-weight-black">
                      {{
                        `${$tc(item.orderStatus.split(' - ')[0], 1)} -
                        ${$t(item.orderStatus.split(' - ')[1])}`
                      }}
                    </span>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </i-card-list>
      </div>

      <!-- Listado por órdenes de venta -->
      <div v-if="tabs !== 0 && showGlobalMode !== 'simple'">
        <i-card-list
          ref="cardListGrid"
          class="mt-2 px-2"
          api="sale"
          app="sales.order"
          dontHeader
          dontColor
          dontRemove
          simple
          :method="'list'"
          :opt="orderListOpt"
          :reload.sync="reload"
          :title="$t('salesorderlist')"
          @click:create="checkPermissions.add && changeRoute({ pk: 'create' })"
          @click:edit="checkPermissions.edit && changeRoute({ pk: $event.pk })"
          @deleted="deleteOrders()"
          @changeShowMode="changeShowMode"
        >
          <template v-slot:[`item`]="{ item, showMode }">
            <v-card-text class="pt-0">
              <v-row class="my-0">
                <!-- Imagen: (solo si showMode es grid o list) -->
                <v-col
                  v-if="showMode !== 'simple'"
                  class="d-flex justify-content-center align-center"
                  :cols="showMode === 'grid' ? 12 : 2"
                >
                  <i-image
                    class="product-image"
                    :style="{
                      width: '10em !important',
                      height: '8em !important'
                    }"
                    :value="item.thumbnail"
                    :preview="true"
                    :readonly="true"
                  />
                </v-col>

                <!-- Cliente, total y vendedor -->
                <v-col
                  class="d-flex flex-column justify-content-center pt-0 g-1"
                  cols="12"
                  :md="showMode != 'grid' ? 2 : 12"
                >
                  <p class="primary--text subtitle-1 font-weight-bold mb-0">
                    {{ `${item.nameOrder}` }}
                  </p>
                  <p class="mb-0">
                    <span class="primary--text font-weight-black">
                      {{ `${$tc('customer', 1)}: ` }}
                    </span>
                    <span class="primary--text subtitle-2">
                      {{ item.name_client || item.client_fullname }}
                    </span>
                    <customer-chat-button
                      :customer="item.customer"
                      :order="item.pk"
                    />
                  </p>
                  <p class="mb-0">
                    <span class="primary--text font-weight-black">
                      {{ `${$tc('salesman', 1)}: ` }}
                    </span>
                    <span class="primary--text subtitle-2">
                      {{ item.name_salesman }}
                    </span>
                  </p>
                </v-col>

                <!-- Subórdenes -->
                <v-col
                  cols="12"
                  :md="showMode == 'simple' ? 7 : showMode == 'list' ? 5 : 12"
                >
                  <v-list v-if="item.number_suborder > 0" class="py-0" dense>
                    <v-list-group @click.stop="">
                      <v-icon slot="appendIcon" size="12">
                        fas fa-arrow-down
                      </v-icon>
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>
                            <span
                              class="primary--text subtitle-2 font-weight-black pl-2"
                            >
                              {{
                                item.number_suborder != 1
                                  ? $tc('suborder', 2)
                                  : $tc('suborder', 1)
                              }}
                              ({{ item.number_suborder }})
                            </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <suborders-list
                        :order="item.pk"
                        @done="getSaleOrders()"
                      />
                    </v-list-group>
                  </v-list>
                </v-col>

                <!-- Acciones, fecha, fecha compromiso y estado -->
                <v-col
                  class="suborders-info"
                  cols="12"
                  :md="showMode != 'grid' ? 3 : 12"
                >
                  <!-- Acciones -->
                  <p
                    v-if="checkPermissions.delete && item.pk"
                    class="text-right mb-2"
                  >
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="secondary"
                          small
                          v-on="on"
                          @click="
                            getCartList(item.pk, item.mainStatus, item.customer)
                          "
                        >
                          {{ $t('action') }}
                        </v-btn>
                      </template>
                      <v-list>
                        <!-- Enviar cotización -->
                        <v-list-item v-if="item.mainStatus === 'quote'">
                          <i-btn
                            classes="mx-1"
                            color="success"
                            icon="fa-paper-plane"
                            outlined
                            :title="$tc('send_quote')"
                            @click="update('send')"
                          />
                        </v-list-item>

                        <!-- Aprobar cotización -->
                        <v-list-item
                          v-if="
                            item.mainStatus === 'quote' ||
                            item.mainStatus === 'sended_quote'
                          "
                        >
                          <i-btn
                            classes="mx-1"
                            color="success"
                            icon="fa-check"
                            outlined
                            :title="$t('aproved_quote')"
                            @click="update('approved')"
                          />
                        </v-list-item>

                        <!-- Agregar productos / Carrito -->
                        <v-list-item
                          v-if="
                            item.mainStatus === 'draft' ||
                            item.mainStatus === 'quote'
                          "
                        >
                          <i-btn
                            classes="mx-1"
                            color="info"
                            icon="fa-cart-plus"
                            outlined
                            :title="`${$t('add', {
                              value: $tc('product', 2)
                            })}`"
                            @click="changeRoute({ pk: item.pk }, 2)"
                          />
                        </v-list-item>

                        <!-- Descargar cotización en PDF -->
                        <v-list-item v-if="item.mainStatus !== 'draft'">
                          <i-btn
                            classes="mx-1"
                            color="error"
                            icon="fa-file-download"
                            outlined
                            :title="$t('download', { value: $t('quote') })"
                            @click="
                              generatePDF(
                                item.pk,
                                true,
                                item.code,
                                item.quotation_code,
                                item.mainStatus
                              )
                            "
                          />
                        </v-list-item>

                        <!-- Mostrar la cotización en una ventana -->
                        <v-list-item v-if="item.mainStatus !== 'draft'">
                          <i-btn
                            classes="mx-1"
                            color="error"
                            icon="fa-file-pdf"
                            outlined
                            :title="$t('print', { value: $t('quote') })"
                            @click="
                              generatePDF(
                                item.pk,
                                false,
                                item.code,
                                item.quotation_code,
                                item.mainStatus
                              )
                            "
                          />
                        </v-list-item>

                        <!-- Ir a la cuenta por cobrar -->
                        <v-list-item
                          v-if="
                            item.mainStatus !== 'draft' &&
                            item.mainStatus !== 'quote' &&
                            item.mainStatus !== 'sended_quote'
                          "
                        >
                          <i-btn
                            classes="mx-1"
                            color="secondary"
                            icon="fa-file-invoice"
                            outlined
                            :title="$t('receivable')"
                            @click="goToReceivable(item.pk)"
                          />
                        </v-list-item>

                        <!-- Eliminar orden -->
                        <v-list-item v-if="item.mainStatus === 'draft'">
                          <i-btn
                            classes="mx-1"
                            color="error"
                            icon="fa-trash"
                            outlined
                            :title="$tc('delete', 1)"
                            @click="remove(item.pk)"
                          />
                        </v-list-item>

                        <!-- Cancelar cotización -->
                        <v-list-item v-if="item.mainStatus !== 'draft'">
                          <i-btn
                            classes="mx-1"
                            color="error"
                            icon="fa-times"
                            outlined
                            :title="`${$t('cancel')} ${$t('quote')}`"
                            @click="update('canceled')"
                          />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </p>

                  <!-- Código de la orden -->
                  <p
                    v-if="item.code"
                    class="text-right mb-0 font-weight-bold caption"
                  >
                    {{ item.code }}
                  </p>

                  <!-- Fecha -->
                  <p class="text-right mb-0 font-weight-bold caption">
                    <span>{{ `${$t('date')}:` }}</span>
                    <span class="primary--text">
                      {{ dateFormat(item.date) }}
                    </span>
                  </p>

                  <!-- Fecha de compromiso -->
                  <p
                    v-if="item.promise_date != null"
                    class="text-right mb-0 font-weight-bold caption"
                  >
                    <span>
                      {{ `${$t('promise_date')}:` }}
                    </span>
                    <span class="primary--text">
                      {{ dateFormat(item.promise_date) }}
                    </span>
                  </p>

                  <!-- Fecha de cierre -->
                  <p
                    v-if="item.dateDone != null"
                    class="text-right mb-0 font-weight-bold caption"
                  >
                    <span>{{ `${$t('dateDone')}:` }}</span>
                    <span class="primary--text">
                      {{ dateFormat(item.dateDone) }}
                    </span>
                  </p>

                  <!-- Estado -->
                  <p class="text-right mb-0 font-weight-bold caption">
                    <span>{{ `${$t('orderstatus')}:` }}</span>
                    <span class="primary--text font-weight-black">
                      {{ $t(item.mainStatus) }}
                    </span>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </i-card-list>
      </div>
      <!--
        Nota: Se usa v-show para no mostrar el componente en el DOM pero
        pudiendo aún usar sus funciones internas. No es lo más recomendado
        pero para este caso específico es la forma más rápida.
      -->
      <quote
        v-if="quotationData.load"
        v-show="false"
        :status="quotationData.status"
        :cartlist="quotationData.cartlist"
        :order="quotationData.order"
        :customer="quotationData.customer"
        @done="getSaleOrders(newStatus)"
        ref="quote"
      />
      <v-btn
        v-show="!$store.getters.getIsloading"
        class="mr-3"
        bottom
        color="secondary"
        fab
        fixed
        right
        v-scroll="onScroll"
        @click="$vuetify.goTo(positionScroll ? 0 : '#pagination')"
      >
        <v-icon
          dark
          v-text="positionScroll ? 'fa-chevron-up' : 'fa-chevron-down'"
        >
        </v-icon>
      </v-btn>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SubordersList from '@/components/sale/MiniSuborders.vue'
import SingleSuborder from '@/components/sale/MiniSuborder.vue'
import Quote from '@/components/sale/quotation.vue'
import CustomerChatButton from '@/components/whatsapp/CustomerChatButton.vue'

export default {
  components: {
    SubordersList,
    SingleSuborder,
    Quote,
    CustomerChatButton
  },
  data() {
    return {
      // Almacena el valor anterior de componentKey
      previousComponentKey: null,
      // Almacena el intervalo para detenerlo si es necesario
      checkInterval: null,
      orderStatus: {
        all: 0,
        draft: 0,
        pdocument: 0,
        sended_document: 0,
        in_process: 0,
        production_ready: 0,
        delivery: 0,
        reception: 0,
        finished: 0,
        canceled: 0,
        correction: 0
      },
      orders: [],
      loading: false,
      positionScroll: 0,
      enableSearch: false,
      tabs: 0,
      reload: false,
      order: null,
      newStatus: '',
      dataForSearch: '',
      openModal: '',
      showGlobalMode: 'simple',
      quotationData: {
        load: false,
        status: '',
        cartlist: [],
        order: '',
        customer: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin',
      company: 'company/getCompanyData',
      me: 'session/me'
    }),
    checkPermissions() {
      return {
        add:
          this.getPermissions([`sales.add_order`]) &&
          this.getPermissions([`base_config.view_term`]) &&
          this.getPermissions([`customer.view_customer`]) &&
          this.getPermissions([`base_config.view_level`]),
        edit:
          this.getPermissions([`sales.change_order`]) &&
          this.getPermissions([`base_config.view_term`]) &&
          this.getPermissions([`customer.view_customer`]) &&
          this.getPermissions([`product.view_product`]) &&
          this.getPermissions([`product.view_producttemplate`]) &&
          this.getPermissions([`base_config.view_level`]) &&
          this.getPermissions([`base_config.view_globaltax`]) &&
          this.getPermissions([`sales.view_orderproduct`]) &&
          this.getPermissions([`sales.add_quotation`]) &&
          this.getPermissions([`sales.view_assigneduser`]) &&
          this.getPermissions([`base_config.view_productiondepartment`]),
        delete: this.getPermissions([`sales.delete_order`]),
        isElevatedRole:
          this.getPermissions([`users.change_profile`]) &&
          this.getPermissions([`auth.change_user`]),
        isDesigner:
          this.getPermissions([`sales.change_assigneduser`]) &&
          this.getPermissions([`sales.view_assigneduser`]),
        isProducer:
          this.getPermissions([`sales.view_assigneddepartment`]) &&
          this.getPermissions([`sales.change_assigneddepartment`])
      }
    },
    subOrderListOpt() {
      return {
        company_id: this.company.pk,
        designer:
          this.checkPermissions.isDesigner &&
          !this.checkPermissions.isElevatedRole
            ? this.me.id
            : '',
        producer:
          this.checkPermissions.isProducer &&
          !this.checkPermissions.isElevatedRole
            ? this.me.id
            : ''
      }
    },
    orderListOpt() {
      return { status: this.tabs, company_id: this.company.pk }
    }
  },
  methods: {
    ...mapActions({
      showConfirmation: 'confirmation/confirmationValue'
    }),
    /**
     * Chequear señal en localStorage para actualizar conteos.
     *
     * @author Ing. Argenis Osorio (argenisosorio10 at gmail)
     */
    checkLocalStorage() {
      // Obtener el valor actual de componentKey desde localStorage
      const currentComponentKey = localStorage.getItem('componentKey')

      // Comparar con el valor anterior
      if (currentComponentKey !== this.previousComponentKey) {
        // Actualizar el valor anterior
        this.previousComponentKey = currentComponentKey

        // Detener el intervalo
        if (this.checkInterval) {
          this.getSaleOrders()

          // Eliminar variable de localStorage
          if (localStorage.componentKey) {
            localStorage.removeItem('componentKey')
          }
        }
      }
    },
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.positionScroll = top > 60
    },
    /**
     * Método para obtener las órdenes de venta y actualizar los contadores de
     * estado.
     * Este método realiza una solicitud a la API para obtener las órdenes de
     * venta según el estado actual seleccionado en las pestañas y actualiza los
     * datos mostrados en la interfaz.
     *
     * @param {string} newStatus - (Opcional) El nuevo estado al que se debe
     * cambiar después de obtener las órdenes. Si no se proporciona, no se
     * realiza el cambio de pestaña.
     *
     * @returns {Promise<void>} - No retorna un valor, pero actualiza las
     * propiedades `orders` y `orderStatus` en el componente.
     */
    async getSaleOrders(newStatus) {
      this.loading = true
      try {
        const params = {
          company_id: this.company.pk,
          status: this.tabs // Estado seleccionado en las pestañas
        }

        // Filter by designer or producer if the user has those roles
        if (
          this.checkPermissions.isDesigner &&
          !this.checkPermissions.isElevatedRole
        ) {
          params.designer = this.me.id
        }
        if (
          this.checkPermissions.isProducer &&
          !this.checkPermissions.isElevatedRole
        ) {
          params.producer = this.me.id
        }
        const res = await this.$api.sale.list({
          opt: {
            params: params
          }
        })

        // Actualizar la lista de órdenes con los resultados obtenidos
        this.orders = res.data.results

        // Solicitar los contadores de estado desde la API
        const status = await this.$api.sale.counter({
          opt: {
            params: {
              company_id: this.company.pk,
              mode: this.showGlobalMode // Modo de visualización actual (simple o detallado)
            }
          }
        })

        // Actualizar los contadores de estado con los datos obtenidos
        this.orderStatus = status.data

        // Calcular el total de todas las órdenes sumando los contadores de cada estado
        this.orderStatus.all =
          status.data.draft +
          status.data.quote +
          status.data.sended_quote +
          status.data.in_process +
          status.data.production_ready +
          status.data.delivery +
          status.data.finished +
          status.data.correction +
          status.data.canceled
      } finally {
        this.loading = false
      }

      // Si se proporciona un nuevo estado, cambiar a la pestaña correspondiente
      if (newStatus) this.getNewTab(newStatus)
    },
    /**
     * Método para actualizar el estado visual de una suborden
     * emitido tras modificación
     *
     * @param {Object} item   Objeto de la suborden en la tabla principal
     * @param {Object} suborder   Objeto con la data actualizada proveniente de la modal
     */
    updateSingleSuborderStatus(item, suborder) {
      if (suborder && suborder.orderStatus) {
        this.$set(item, 'orderStatus', suborder.orderStatus)
      }
      if (suborder && suborder.mainStatus) {
        this.$set(item, 'mainStatus', suborder.mainStatus)
      }
    },
    /**
     * Método para filtrar la información del cliente de la orden
     * @param {Number} customerPK ID del cliente de la orden
     * @returns {Void}
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getCustomer(customerPK) {
      try {
        const customer = await this.$api.customer.show({
          pk: customerPK
        })
        this.quotationData.customer = customer.data
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * Método que consulta la orden de venta para asegurarse que llega la
     * información en con el formato adecuado, ya que el componente de
     * cotizaciones no recibe un dato sino un objeto completo.
     *
     * @param {Number} orderPK ID de la orden
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getOrder(orderPK) {
      try {
        const orderData = await this.$api.sale.show({
          pk: orderPK
        })
        this.quotationData.order = orderData.data
        this.quotationData.status = orderData.data.mainStatus
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * Método para filtrar los productos de la orden
     * @param {Number} orderPK ID de la orden de venta
     * @param {String} currentStatus Estado de la orden
     * @param {Number} customerPK ID del cliente de la orden
     * @returns {Void}
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getCartList(orderPK, currentStatus, customerPK) {
      try {
        await this.getCustomer(customerPK)
        await this.getOrder(orderPK)
        const { data: cart } = await this.$api.sale.suborder.show({
          pk: orderPK,
          opt: { params: { order: true } }
        })
        this.quotationData.cartlist = cart
        this.quotationData.load = currentStatus !== 'draft'
        if (cart.length === 0 && currentStatus === 'quote') {
          this.$toast.error(this.$tc('select_prod', 1))
        }
      } catch (error) {
        console.error('Error al obtener la lista del carrito:', error)
      }
    },
    /**
     * Método para realizar acciones en la cotizacion de un orden
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    update(mode) {
      this.newStatus = mode
      this.$refs['quote'].update(mode)
    },
    /**
     * Método para cambiar de pestaña al nuevo estado de orden
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     */
    getNewTab(mode) {
      this.tabs = mode
      if (mode == 'send') this.tabs = 'sended_quote'
      if (mode == 'approved') this.tabs = 'in_process'
    },
    /**
     * Método para redireccionar la aplicación a una orden de venta específica.
     * @param {Number} suborderPK   ID de la orden de venta que se quiere
     *                              consultar.
     * @param {Number} [page=0]     Página del formulario de órdenes de venta
     *                              que se quiere mostrar al redireccionar.
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    changeRoute(order = { pk: 0 }, page = 0) {
      this.$router.push({
        name: 'sale-pk',
        params: {
          pk: this.codification({ code: order.pk }),
          step: this.codification({ code: page })
        }
      })
    },
    /**
     * Método para redireccionar la aplicación a una cuenta por cobrar
     * específica.
     *
     * @param {Number} receivable        ID de la cuenta por cobrar
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async goToReceivable(orderPK) {
      await this.$api.invoice.receivable
        .byOrder({
          pk: orderPK
        })
        .then((response) => {
          this.$router.push({
            name: 'receivable-pk',
            params: {
              pk: this.codification({ code: response.data.pk })
            }
          })
        })
        .catch((error) => {
          console.error(error)
        })
    },
    /**
     * Método para generar una cotización de orden de venta en un pdf
     *
     * @param   {Number} orderPK    Primary Key de la orden
     * @param   {Boolean} download  Indica si el archivo es para descargar o
     *                              para verlo en el navegador.
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    generatePDF(
      orderPK,
      download = false,
      passedCode = '',
      quotationCode = '',
      orderMainStatus = ''
    ) {
      const order = this.orders.find((o) => o.pk === orderPK)
      let quoteCode = quotationCode || (order && order.quotation_code) || ''
      let orderCode = ''

      if (order && !orderCode) {
        orderCode = order.code || ''
      }

      if (passedCode) {
        let baseCode = passedCode.includes('-')
          ? passedCode.split('-').slice(0, -1).join('-')
          : passedCode
        if (baseCode.startsWith('COT')) {
          if (!quoteCode) quoteCode = baseCode
        } else if (baseCode.startsWith('ORD') || baseCode) {
          orderCode = baseCode
        }
      }

      const mainStatus = orderMainStatus || (order && order.mainStatus) || ''
      const isApproved =
        mainStatus &&
        mainStatus !== 'quote' &&
        mainStatus !== 'sended_quote' &&
        mainStatus !== 'correction' &&
        mainStatus !== 'draft'

      let finalCode = ''
      if (isApproved && quoteCode && orderCode && quoteCode !== orderCode) {
        finalCode = `${quoteCode}_${orderCode}`
      } else {
        finalCode = quoteCode || orderCode
      }

      const codeSuffix = finalCode ? `_${finalCode}` : ''
      this.downloadFile({
        api: 'quotation',
        method: 'pdf',
        filename: `Quotation${codeSuffix}`,
        action: download ? 'download' : 'window',
        ext: 'pdf',
        opt: { pk: orderPK }
      })
    },
    async changeShowMode(show) {
      this.showGlobalMode = show
      this.loading = true
      try {
        const response = await this.$api.sale.counter({
          opt: {
            params: {
              company_id: this.company.pk,
              mode: this.showGlobalMode
            }
          }
        })
        this.orderStatus = response.data
        this.orderStatus.all =
          response.data.draft +
          response.data.quote +
          response.data.sended_quote +
          response.data.in_process +
          response.data.production_ready +
          response.data.delivery +
          response.data.finished +
          response.data.correction +
          response.data.canceled
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    deleteOrders() {
      this.reload = true
      this.getSaleOrders(this.tabs)
    },
    /**
     * Método para eliminar órdenes de venta, reemplaza al implementado en
     * i-card-list porque se usa en más de una tabla que apunta a dos endpoints
     * distintos.
     *
     * @param   {Number} pk    Primary Key de la orden
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    remove(pk) {
      this.showConfirmation({
        show: true,
        model: this.$t('sale_order'),
        title: this.$tc('delete', 1),
        type: 'error white--text',
        content: this.$t('confirm_delete'),
        alert: `${this.$t('success', {
          model: this.$t('sale_order'),
          action: this.$tc('delete', 2)
        })}`,
        confirm: async () => {
          await this.$api.sale.remove({ pk: pk })

          if (this.$refs.cardListGrid) {
            let list = Array.isArray(this.$refs.cardListGrid)
              ? this.$refs.cardListGrid[0]
              : this.$refs.cardListGrid
            if (list && list.itemsInternal) {
              list.itemsInternal = list.itemsInternal.filter(
                (item) => item.pk !== pk && item.order !== pk
              )
            }
          }
          if (this.$refs.cardListSimple) {
            let list = Array.isArray(this.$refs.cardListSimple)
              ? this.$refs.cardListSimple[0]
              : this.$refs.cardListSimple
            if (list && list.itemsInternal) {
              list.itemsInternal = list.itemsInternal.filter(
                (item) => item.pk !== pk && item.order !== pk
              )
            }
          }

          if (this.orderStatus.draft > 0) {
            this.orderStatus.draft--
          }
          if (this.orderStatus.all > 0) {
            this.orderStatus.all--
          }
        }
      })
    },
    clearUrlQuery() {
      if (this.openModal) {
        // Limpiar visualmente la URL sin afectar al Router ni disparar recargas.
        // La navegación interna ahora se maneja por EventBus, pero actualizamos
        // la URL para mantener la consistencia si el usuario recarga.
        const url = new URL(window.location.href)
        if (url.searchParams.has('openModal')) {
          url.searchParams.delete('openModal')
          url.searchParams.delete('tab')
          window.history.replaceState({}, '', url.toString())
        }
        this.openModal = false
      }
    }
  },
  mounted() {
    // Escuchar evento global (EventBus) emitido desde NotificationBell.vue
    // Permite abrir el modal de suborden sin recargar la página completa.
    this.$root.$on('open-modal-suborder', (payload) => {
      // payload puede ser un ID (legacy/simple) o un objeto {id, tab}
      this.openModal = payload

      // Construir URL params
      const id = typeof payload === 'object' ? payload.id : payload
      const tab = typeof payload === 'object' ? payload.tab : null

      // Actualizar URL usando History API para soporte de F5 (sin disparar router)
      const url = new URL(window.location.href)
      url.searchParams.set('openModal', id)
      if (tab) {
        url.searchParams.set('tab', tab)
      } else {
        url.searchParams.delete('tab')
      }
      window.history.pushState({}, '', url.toString())
    })

    // Inicializar el valor anterior de componentKey
    this.previousComponentKey = localStorage.getItem('componentKey')

    // Verificar el localStorage.
    this.checkInterval = setInterval(() => {
      this.checkLocalStorage()
    }, 2000)

    // Actualizar los conteos de la lista
    this.getSaleOrders()

    // Verificar si el parámetro "details" existe y asignarlo a "dataForSearch"
    if (this.$route.params.details) {
      this.dataForSearch = this.$route.params.details
    }

    // Orden de abrir el modal (carga inicial / externa)
    if (this.$route.query.openModal || this.$route.params.openModal) {
      const id = this.$route.query.openModal || this.$route.params.openModal
      const tab = this.$route.query.tab || null
      // Si hay tab, openModal será un objeto
      this.openModal = tab ? { id, tab } : id
    } else {
      this.openModal = false
    }
  },
  beforeDestroy() {
    this.$root.$off('open-modal-suborder')
    // Limpiar el intervalo al desmontar el componente
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
  },
  watch: {
    '$route.query.openModal'(val) {
      if (val) {
        this.openModal = val
      } else {
        this.openModal = false
      }
    },
    tabs() {
      this.getSaleOrders()
    },
    '$vuetify.breakpoint.xsOnly': {
      handler(val) {
        if (val) {
          this.showMode = 'simple'
        }
      }
    }
  }
}
</script>
<style lang="sass">
.theme--dark.v-tabs > .v-tabs-bar
  background-color: transparent

.suborders-info
  display: flex
  flex-direction: column
  justify-content: center
  gap: .25rem
  color: var(--v-muted-darken3)
.theme--dark
  .suborders-info
    color: var(--v-muted-lighten1)
</style>
